import { functionality } from "@/prisma/generated/enums";

export type PermissionContext = {
  userId: string;
  roles: number[];
  functionalities: functionality[];
  isAdmin: boolean;
};

export type RoutePermission = {
  roles?: readonly number[];
  functionality?: functionality;
};

export function evaluatePermission(
  ctx: PermissionContext,
  policy: RoutePermission,
): boolean {
  if (ctx.isAdmin) return true;

  const hasRoles = !!policy.roles?.length;
  const hasCathrin = !!policy.functionality;

  const roleOk = hasRoles && ctx.roles.some((r) => policy.roles!.includes(r));

  const cathrinOk =
    hasCathrin && ctx.functionalities.includes(policy.functionality!);

  if (!hasRoles && !hasCathrin) return true;

  if (hasRoles && hasCathrin) return roleOk || cathrinOk;

  if (hasRoles) return roleOk;

  return cathrinOk;
}
